type VendorGstLike = {
  gst_treatment?: string | null;
  gst_category?: string | null;
};

/**
 * Fills missing gst_treatment / gst_category on a review raw_json snapshot only.
 * Does not mutate billJson or field_changes — used when building ChangeDetails.
 */
export function withVendorGstInReviewRawJson<T extends object>(
  rawJson: T | null | undefined,
  vendor: VendorGstLike | null | undefined,
): T | null | undefined {
  if (!rawJson || !vendor) {
    return rawJson;
  }

  const record = rawJson as Record<string, unknown>;
  const needsTreatment = !String(record.gst_treatment ?? "").trim();
  const needsCategory = !String(record.gst_category ?? "").trim();
  if (!needsTreatment && !needsCategory) {
    return rawJson;
  }

  const treatment = String(vendor.gst_treatment ?? "").trim();
  const category = String(vendor.gst_category ?? "").trim();

  return {
    ...rawJson,
    ...(needsTreatment && treatment ? { gst_treatment: treatment } : {}),
    ...(needsCategory && category ? { gst_category: category } : {}),
  };
}
